import React from 'react';

const baseStyle = { margin: 0, cursor: 'pointer', verticalAlign: 'middle' };

/**
 * TanStack 그리드 셀 - 체크박스 인라인 에디터 (값: 'Y'/'N' 문자열, RealGrid 호환)
 * @param {string} value - 현재 값 ('Y' | 'N' 등)
 * @param {Function} onSave - (value: 'Y' | 'N') => void
 * @param {Function} onCancel - () => void (Esc 시)
 * @param {Function} onEnterMoveDown - () => void. Enter 시 저장 후 아래 셀로 이동
 * @param {Function} onTabMove - (direction: 'left'|'right') => void. Tab 시 저장 후 다음 셀로 이동
 * @param {Object} meta - { trueValue?: string, falseValue?: string } (기본 'Y'/'N')
 */
const CheckboxCellEditor = ({
  value = '',
  onSave,
  onCancel,
  onEnterMoveDown,
  onEnterMoveUp,
  onTabMove,
  meta = {},
}) => {
  const trueVal = meta?.trueValue ?? 'Y';
  const falseVal = meta?.falseValue ?? 'N';
  const checked = value === trueVal;

  const toggleAndSave = () => {
    const next = checked ? falseVal : trueVal;
    onSave?.(next, { focusGrid: false });
  };

  return (
    <input
      type="checkbox"
      checked={checked}
      onChange={() => toggleAndSave()}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (e.key === ' ') toggleAndSave();
          else {
            toggleAndSave();
            if (e.shiftKey) onEnterMoveUp?.();
            else onEnterMoveDown?.();
          }
        }
        if (e.key === 'Tab') {
          e.preventDefault();
          onSave?.(checked ? trueVal : falseVal, { focusGrid: false });
          onTabMove?.(e.shiftKey ? 'left' : 'right');
          return;
        }
        if (e.key === 'Escape') onCancel?.();
      }}
      style={baseStyle}
      autoFocus
    />
  );
};

export default CheckboxCellEditor;
